import React, { Fragment, useState, useEffect } from 'react';
import {
    Table,
    Button,
    Row,
    Col,
    CustomInput,
    Modal,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Input
} from 'reactstrap';
import Select from 'react-select';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
    faCopy,
    faExternalLinkAlt,
    faQrcode,
    faTrash
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';

export default function GenerateQRCode({
    pageSettings,
    propertyId,
    urlsList,
    queryString,
    handleChangeQueryString,
    deleteUrl,
    saveQueryString
}) {
    const [sourceData, setSourceData] = useState({
        isEnabled: false,
        membershipGroup: "",
        codeList: [""]
    });
    const [selectedCodes, setSelectedCodes] = useState([]);
    const [codeList, setCodeList] = useState(['']);
    const [qrVisible, setQrVisible] = useState(false);
    const [imgUrl, setImgUrl] = useState({ url: "", no: "" });
    const [roomUrlData, setRoomUrlData] = useState([]);

    useEffect(() => {
        if (pageSettings.urlParams !== undefined && pageSettings.urlParams !== null) {
            var codelist = [""];
            if (pageSettings.urlParams.trackingCode !== null &&
                pageSettings.urlParams.trackingCode.codeList !== null &&
                pageSettings.urlParams.trackingCode.codeList.length > 0) {
                pageSettings.urlParams.trackingCode.codeList.map((item, i) => {
                    codelist.push({ label: item, value: item, key: i });
                });
            }
            var selectedcode = [];
            if (pageSettings.urlParams.trackingCode !== null &&
                pageSettings.urlParams.trackingCode.membershipGroup !== null) {
                selectedcode = codelist.filter(i => i.value === pageSettings.urlParams.trackingCode.membershipGroup).map(m => m);
            }
            setSelectedCodes(selectedcode);
            setCodeList(codelist);
        }
        setSourceData({
            isEnabled: pageSettings.urlParams.trackingCode.isEnabled,
            membershipGroup: pageSettings.urlParams.trackingCode.membershipGroup,
            codeList: pageSettings.urlParams.trackingCode.codeList
        });
        var roomRange = pageSettings.roomNumberRange;
        var urlist = [];
        roomRange.map((o) => {
            urlsList.filter(k => k.roomNumber >= o.startRoomNo && k.roomNumber <= o.endRoomNo).sort((a, b) => a.roomNumber - b.roomNumber).
                map(l => {
                    urlist.push(l);
                });
        });
        setRoomUrlData(urlist);
    }, [propertyId, urlsList]);

    const checkedSource = (e) => {
        setSourceData({ ...sourceData, isEnabled: e.target.checked });
    }
    const handleChangeCodeList = (selectedCodelist) => {
        setSelectedCodes(selectedCodelist);
        var codelist = [];
        if (selectedCodelist !== null && selectedCodelist !== undefined) {
            codelist = selectedCodelist !== null && selectedCodelist !== undefined ? [selectedCodelist.value] : [];
        }
        setSourceData({ ...sourceData, codeList: codelist });
    };
    const OpenQrCode = (url, no) => {
        setImgUrl({ url: url, no: no });
        setQrVisible(true);
    }
    const toggle = () => {
        setImgUrl("");
        setQrVisible(false);
    }
    const openInNewTab = url => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const download = (qrurl) => {
        const link = document.createElement("a");

        link.href = qrurl.url;

        link.download = qrurl.no + ".png";

        link.click();
    }

    return (<Fragment>
        <div className='row mb-3 mt-3'>
            <div className='col-md-12 mb-3'>
                <p>Pass source param to track where the QR Codes scans or URL clicks are happening from. Any value can be passed e.g. lobby, restaurant, room. </p>
            </div>
            <div className='col-md-12'>
                <Row>
                    <Col className="col-md-12 d-flex">
                        <Input type="text" className="w-100 input_sty" value={queryString} onChange={(e) => handleChangeQueryString(e)}></Input>
                        <Button color="primary"
                            size="xs"
                            className="ml-2"

                            onClick={() => saveQueryString()}>Save</Button>
                    </Col>
                </Row>
            </div>
        </div>
        <Row>
            {roomUrlData.length > 0 &&
                <Col className="co-md-12 mt-2 mb-4 text-right">
                    <Button
                        color="secondary"
                        size="xs"
                        className="mr-1"

                        onClick={() => deleteUrl(null, true)}
                    >Delete All</Button>
                </Col>
            }
            {/* {roomUrlData.length > 0 && roomUrlData.filter((o) => o.qrCode !== null && o.qrCode !== "").length > 0 &&
                <Col className="co-md-12 mt-2 mb-4 text-right">
                    <Button
                        color="primary"
                        size="xs"
                        className="mr-1"
                        outline
                    >Download QR Codes</Button>
                </Col>
            } */}
            <Col className="col-md-12">
                {roomUrlData.length > 0 &&
                    <Table className='qr-room-list'>
                        <thead>
                            <tr>
                                <th>Room Number</th>
                                <th>Encrypted Room Number</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {roomUrlData.length > 0 &&
                                roomUrlData.map((row, i) => (
                                    <tr key={i}>
                                        <th scope="row">{row.roomNumber}</th>
                                        <td>{row.encryptedRoomNumber}</td>
                                        <td>
                                            <a title='Open URL'>
                                                <FontAwesomeIcon
                                                    icon={faExternalLinkAlt}
                                                    color="#90caf9"
                                                    cursor="pointer"
                                                    id="openTip"
                                                    onClick={() => openInNewTab(row.url)}
                                                />
                                            </a>
                                            <b> | </b>
                                            <a title='Copy URL'>
                                                <CopyToClipboard
                                                    text={row.url}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faCopy}
                                                        style={{ color: 'var(--theme-color-1)' }}
                                                        cursor="pointer"
                                                    ></FontAwesomeIcon>
                                                </CopyToClipboard>
                                            </a>
                                            {row.qrCode !== null && row.qrCode !== "" &&
                                                <Fragment><b> | </b>
                                                    <a title='View QR Code'>
                                                        <FontAwesomeIcon
                                                            icon={faQrcode}
                                                            style={{ color: 'var(--theme-color-1)' }}
                                                            cursor="pointer"
                                                            id="qrTip"
                                                            onClick={() => OpenQrCode(row.qrCode, row.roomNumber)}
                                                        />
                                                    </a>
                                                </Fragment>
                                            }
                                            <b> | </b>
                                            <a title='Delete URL'>
                                                <FontAwesomeIcon
                                                    icon={faTrash}
                                                    style={{ color: 'var(--theme-color-1)' }}
                                                    cursor="pointer"
                                                    onClick={() => deleteUrl(row.id, false)}
                                                ></FontAwesomeIcon>
                                            </a>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                }
            </Col>
        </Row>
        <Modal isOpen={qrVisible} toggle={() => toggle()}>
            <ModalHeader toggle={() => toggle()}>QR Code</ModalHeader>
            <ModalBody>
                <Row>
                    <Colxx sm={12} className="text-center">
                        <img src={imgUrl.url} width={200}></img>
                    </Colxx>
                </Row>
            </ModalBody>
            <ModalFooter
                className="d-flex justify-content-space-between "
            >
                <Button
                    color="primary"
                    onClick={() => download(imgUrl)}
                >
                    Download QR Code
                </Button>
                <Button
                    color="secondary"
                    onClick={() => toggle()}
                >
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    </Fragment>);
}